import vue from '@/business/main'
import Bussiness from 'Utils/business'

/**
 * 火车票正常单操作方法
 * @param {Object} detail 火车订单详
 */

export default {
  /**
   * 取消
   */
  async cancel (detail) {
    if (detail.orderStatus === '1') {
      vue.$dialog({ message: '订单正在申请占座中无法取消，请稍后再试' })
      return
    } else {
      await vue.$dialog.confirm({
        message: '您确定要取消吗？',
      }).then(async () => {
        try {
          await vue.$api['trOrder/cancelOrder']({orderId: detail.id})
          return vue.$dialog.alert({ message: '取消订单成功' })
        } catch (res) {
          return res
        }
      })
    }
  },
  /**
   * 送审
   */
  approval (detail) {
    detail.orderType = $dict.ORDER_TYPE.tr.normal
    Bussiness.ApprovalSend(detail)
  },
  async revertApproval (detail) {
    detail.orderType = $dict.ORDER_TYPE.tr.normal
    await Bussiness.ApprovalRevert(detail)
    return true
  },
  /**
   * 前往申请改签页面
   */
  change (detail) {
    if (!Bussiness.DetectorNearTime(detail, 'change')) {
      return false
    } else {
      vue.$dialog.confirm({
        message: '如已打印纸质车票，只能去车站办理退改！未打印纸质车票，可以线上提交办理。'
      }).then(() => {
        vue.$router.push({ path: `/tr/ApplyAlter/${detail.id}` })
      })
    }
  },
  /**
   * 前往改签详情页面
   */
  goChangeDetail (detail) {
    vue.$router.push({ path: `/tr/ChangeDetail/${detail.changeId}` })
  },
  /**
   * 前往申请退票页面
   */
  refund (detail) {
    if (!Bussiness.DetectorNearTime(detail, 'refund')) {
      return false
    } else {
      vue.$dialog.confirm({
        message: '如已打印纸质车票，只能去车站办理退改！未打印纸质车票，可以线上提交办理。'
      }).then(() => {
        vue.$router.push({ path: '/tr/ApplyRefund', query: {
          id: detail.id,
          applyType: ''
        }})
      })
    }
  },
  /**
   * 前往退票详情页面
   */
  goRefundDetail (detail) {
    vue.$router.push({ path: `/tr/RefundDetail/${detail.changeId}` })
  },
  /**
   * 查看保险详情
   */
  goInsureDetail (detail) {
    vue.$router.push({ path: `/tr/RefundDetail/${detail.changeId}` })
  },
  /**
   * 查看审批进度
   */
  approvalRule (detail) {
    vue.$router.push({ path: `/tr/RefundDetail/${detail.changeId}` })
  },
  /**
   * 出差申请单详情
   */
  approvalDetail (detail) {
    vue.$router.push({ path: `/tr/RefundDetail/${detail.changeId}` })
  }
}
